import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable()
export class GdprAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'GDPR';
  public readonly requireViewContext = true;

  public trackInsertGDPRLink(
    kind: 'removalRequest' | 'correctionRequest' | 'consentRequestLink',
  ): void {
    this.track('InsertGDPRLink', { kind });
  }

  public trackOpenStatusDetails(): void {
    this.track('OpenStatusDetails');
  }

  public trackExtendRetentionPeriod(mode: 'single' | 'bulk', candidatesCount: number = 1): void {
    this.track('ExtendRetentionPeriod', { mode, candidatesCount });
  }

  public trackSetConsentPrivacyPolicyLink(): void {
    this.track('SetConsentPrivacyPolicyLink');
  }

  public trackEnableGDPR(): void {
    this.track('EnableGDPR');
  }

  public trackDisableGDPR(): void {
    this.track('DisableGDPR');
  }
}
